// extracted by mini-css-extract-plugin
var _1 = "NodeV2SvgInfo_root__cf853";
var _2 = "NodeV2SvgInfo_size__b7cc1";
var _3 = "NodeV2SvgInfo_svg__4574c";
export { _1 as "root", _2 as "size", _3 as "svg" }
